"use client";

import sech from "../assets/images/search-lg.svg";

// import {useNavigate} from "react-router";
import { useEffect, useState } from "react";
import axios from "axios";
import OtherHeader from "../components/otherheader";
import angledown from "../assets/images/angle-down.svg";
import { useLocation, useNavigate } from "react-router";
import mark from "../assets/images/mycheck.svg";
import LoaderDate from "../components/loaderData";
import empty from "../assets/images/emptyadmin.svg";
import US from "../assets/images/EU.svg";
import USD from "../assets/images/US.svg";
import NGN from "../assets/images/ngnnigeria.jpg";
import EU from "../assets/images/GB.svg";
import GB from "../assets/images/GB.svg";
import KES from "../assets/images/KES.svg";
import USDC from "../assets/images/USDC.svg";
import USDT from "../assets/images/USDT.svg";
import successmark from "../assets/images/bluesuccess.svg";
import currencyPairCheck from "../components/logoCurrency";
import AmountCheck from "../components/amountcheck";
import { debounce } from "../transaction/home";
import PaginationV2 from "../components/v2/pagination";
import { paginationData } from "../libs/constants";


const status = ["All", "Approved", "Pending", "Cancelled", "Rejected", "Overdue", "Disbursed"];
const paymentRequestStatus = ["Approved", "Pending", "Rejected"];
const sort = [
    "Recent",
    "Amount (High to Low)",
    "Amount (Low to High)",
    "Name (A-Z)",
    "Name (Z-A)",
];
const requestType = ["All", "Shipping", "Inventory", "Cashflow"];

const FinanceHome = () => {
    const [order, setOrder] = useState("ASC");
    const [selectedIndex, setselectedIndex] = useState(0);
    const navigate = useNavigate();
    const [isStatus, setisStatus] = useState(false);
    const [isSort, setisSort] = useState(false);
    const [isRequest, setisRequest] = useState(false);

    const [currentPageFactoring, setCurrentPageFactoring] = useState(1);
    const [currentPageCredit, setCurrentPageCredit] = useState(1);
    const [currentPageTrade, setCurrentPageTrade] = useState(1);
    const [currentPageInventory, setCurrentPageInventory] = useState(1);
  const [currentPagePayment, setCurrentPagePayment] = useState(1);

    const [totalCountPayable, setTotalCountPayable] = useState(0);
    const [totalCountReceivable, setTotalCountReceivable] = useState(0);
  const [totalCountPayment, setTotalCountPayment] = useState(0);
    const [totalCountInventory, setTotalCountInventory] = useState(0);

    const [data, setData] = useState([]);
    const [inventoryFinance, setInventoryFinance] = useState([]);
    const [paymentFinance, setPaymentFinance] = useState([]);
    const [search, setSearch] = useState("");
    const [selectedstatus, setselectedstatus] = useState("All");
    const [selectedindexstatus, setselectedindexstatus] = useState(0);
    const [selectedsort, setselectedsort] = useState("Recent");
    const [selectedindexsort, setselectedindexsort] = useState(0);
    const [selectedrequest, setselectedrequest] = useState("All");
    const [selectedindexrequest, setselectedindexrequest] = useState(0);
    const [isloading, setisloading] = useState(true);
    const [payableFinance, setPayableFinance] = useState([]);
    const [receivableFinance, setReceivableFinance] = useState([]);
  const [paymentFinanceNew, setPaymentFinanceNew] = useState([]);
    const [inventory, setInventory] = useState([]);
    const [defaultcur, setdefault] = useState(1);
    const [isdrop, setisdrop] = useState(false);
    const [PageSize, setPageSize] = useState(1);
    const [payableFinancePageSize, setPayableFinancePageSize] = useState(1);
    const [receivableFinancePageSize, setReceivableFinancePageSize] = useState(1);
  const [paymentFinancePageSize, setPaymentFinancePageSize] = useState(1);
    const [inventoryPageSize, setInventoryPageSize] = useState(1);
    const [overviewData, setOverviewData] = useState({});
    const [paymentRequestCurrentPage, setPaymentRequestCurrentPage] = useState(1);
    const [payableFinanceCurrentPage, setPayableFinanceCurrentPage] = useState(1);
    const [receivableFinanceCurrentPage, setReceivableFinanceCurrentPage] = useState(1);
  const [paymentFinanceCurrentPage, setPaymentFinanceCurrentPage] = useState(1);
    const [inventoryCurrentPage, setInventoryCurrentPage] = useState(1);

    const [tab, settab] = useState(localStorage.getItem("activeTab") || "Payments");
    const location = useLocation();

    const [stat, setstat] = useState([]);
  const [cur, setcur] = useState("");
    const [selectedcurindex, setselectedcurindex] = useState(0);

  const [currencciess] = useState([
        {
            img: EU,
            name: "GBP",
            title: " British Pounds",
        },
        {
            img: NGN,
            name: "NGN",
            title: "NG Naira",
        },
        {
            img: US,
            name: "EUR",
            title: "Euro",
        },
        {
            img: USD,
            name: "USD",
            title: "Dollar",
    },
    { name: "KES", img: KES, title: "Kenyan Shilling" },
    { name: "USDC", img: USDC, title: "USDC" },
    { name: "USDT", img: USDT, title: "USDT" },
  ])

    const statusColors = {
        pending: "#DB6704",
        disbursed: "#11A811",
        approved: "#11A811",
    };
    const buildQueryString = (basePage, financeType) => {
        const params = new URLSearchParams({
            page: basePage,
            // pageSize: PageSize,
            financeType: financeType,
        });

        if (search) params.append("q", search);
        if (selectedstatus !== "All") params.append("status", selectedstatus.toLowerCase());
        if (selectedrequest !== "All") params.append("requestType", selectedrequest);
        if (selectedsort !== "Recent") params.append("sort", selectedsort);
      if (cur) params.append("currency", cur);

        return params.toString();
    };

    useEffect(() => {
        const fetchPayableFinance = async () => {
            setisloading(true);
            try {
                const queryString = buildQueryString(currentPageCredit, "payable_finance");
                const response = await axios.get(`/v1/admin/finance/all?${queryString}`);
                setPayableFinance(response?.data?.data);
                setTotalCountPayable(response?.data?.meta?.totalItems);
            } catch (e) {
                console.log(e);
            } finally {
                setisloading(false);
            }
        };
        fetchPayableFinance();
    }, [cur, currentPageCredit, search, selectedstatus, selectedrequest, selectedsort]);

    useEffect(() => {
        const fetchReceivableFinance = async () => {
            setisloading(true);
            try {
                const queryString = buildQueryString(receivableFinanceCurrentPage, "receivable_finance");
                const res = await axios.get(`/v1/admin/finance/all?${queryString}`);
                setReceivableFinance(res?.data?.data);
                setReceivableFinancePageSize(res?.data?.meta?.totalPages);
                setReceivableFinanceCurrentPage(res?.data?.meta?.currentPage);
            } catch (e) {
                console.log(e);
            } finally {
                setisloading(false);
            }
        };
        fetchReceivableFinance();
    }, [receivableFinanceCurrentPage, receivableFinancePageSize, search, selectedstatus, selectedrequest, selectedsort]);

    // Inventory Finance
  // useEffect(() => {
  //     const fetchInventoryFinance = async () => {
  //         setisloading(true);
  //         try {
  //             const queryString = buildQueryString(inventoryCurrentPage, "inventory_finance");
  //             const response = await axios.get(`/v1/admin/finance/all?${queryString}`);
  //             setInventoryFinance(response.data.data);
  //             setInventoryCurrentPage(response.data?.meta.currentPage);
  //             setInventoryPageSize(response.data?.meta.totalPages);
  //         } catch (e) {
  //             console.log(e);
  //         } finally {
  //             setisloading(false);
  //         }
  //     };
  //     fetchInventoryFinance();
  // }, [inventoryCurrentPage, inventoryPageSize, search, selectedstatus, selectedrequest, selectedsort]);

  // Payment Finance
  useEffect(() => {
    const fetchPaymentFinance = async () => {
      setisloading(true);
      try {
        const queryString = buildQueryString(paymentFinanceCurrentPage, "payment_finance");
        const response = await axios.get(`/v1/admin/finance/all?${queryString}`);
        setPaymentFinanceNew(response.data.data);
        setPaymentFinanceCurrentPage(response.data?.meta.currentPage);
        setPaymentFinancePageSize(response.data?.meta.totalPages);
      } catch (e) {
        console.log(e);
      } finally {
        setisloading(false);
      }
    };
    fetchPaymentFinance();
  }, [paymentFinanceCurrentPage, paymentFinancePageSize, search, selectedstatus, selectedrequest, selectedsort]);

    useEffect(() => {
        const fetchPaymentRequests = async () => {
            setisloading(true);
            try {
                const params = new URLSearchParams({
                    page: paymentRequestCurrentPage,
                    currency: cur,
                });

                if (search) params.append("q", search);
                if (selectedstatus !== "All") params.append("status", selectedstatus.toLowerCase());
                if (selectedrequest !== "All") params.append("requestType", selectedrequest);
                if (selectedsort !== "Recent") params.append("sort", selectedsort);

                const response = await axios.get(
                    `/v1/admin/finance/pay/all?${params.toString()}`
                );
                setPaymentFinance(response?.data?.data);
                setPageSize(response?.data?.meta?.totalPages);
                setPaymentRequestCurrentPage(response?.data?.meta?.currentPage);
            } catch (e) {
                console.log(e);
            } finally {
                setisloading(false);
            }
        };
        fetchPaymentRequests();
    }, [cur, search, selectedstatus, selectedrequest, selectedsort, paymentRequestCurrentPage]);

    useEffect(() => {
        setCurrentPageFactoring(1);
        setCurrentPageCredit(1);
        setCurrentPageTrade(1);
      setCurrentPageInventory(1);
      setCurrentPagePayment(1)
    }, [search, selectedstatus, selectedrequest, selectedsort, tab]);

    const currentTableData = paymentFinance ?? [];
    const currentTableDataPayableFinance = payableFinance;
    const currentTableDataReceivableFinance = receivableFinance;
    const currentTableDataInventory = inventoryFinance;
  const currentPaymentFinance = paymentFinanceNew;

    useEffect(() => {
        const fetchPayableFinance = async () => {
            const params = new URLSearchParams({
                page: payableFinanceCurrentPage,
                currency: cur,
            });

            if (search) params.append("q", search);
            if (selectedstatus !== "All") params.append("status", selectedstatus.toLowerCase());
            if (selectedrequest !== "All") params.append("requestType", selectedrequest);
            if (selectedsort !== "Recent") params.append("sort", selectedsort);
            await axios
                .get(`/v1/admin/finance/all?financeType=payable_finance&${params.toString()}`)
                .then((res) => {
                    setPayableFinance(res?.data?.data);
                    setPayableFinanceCurrentPage(res?.data?.meta?.currentPage);
                    setPayableFinancePageSize(res?.data?.meta?.totalPages);
                })
                .catch((e) => {
                    console.log(e);
                });
        };
        fetchPayableFinance();
    }, [cur, payableFinanceCurrentPage, search, selectedstatus, selectedrequest, selectedsort, payableFinancePageSize]);

    const goToDetails = (items, p) => {
        navigate(`/finance/${items._id}`, {
            state: {
                ...items,
                customtype: p,
            },
        });
    };

    useEffect(() => {
        const fetchOverview = async () => {
            await axios
                .get(`/v1/admin/finance/dashboard/overview`)
                .then((res) => {
                    setOverviewData(res?.data?.data);
                })
                .catch((e) => {
                    console.log(e);
                });
        };
        fetchOverview();
        return () => {
            setOverviewData([]);
        };
    }, []);

    const searchStat = async (value, tabs) => {
        if (tabs === "Payments") {
            await axios
                .get(`/v1/admin/finance/pay/all?page=${currentPageFactoring}`)
                .then((res) => {
                    setstat(res.data.data);
                })
                .catch((e) => {
                    console.log(e);
                });
        } else if (tabs === "payable finance") {
            await axios
                .get(`/v1/admin/finance/all?page=${currentPageCredit}&financeType=payable_finance`)
                .then((res) => {
                    setstat(res.data.data);
                    setPayableFinance(res.data.data);
                    setTotalCountPayable(res.data?.meta.itemsPerPage || res.data.data.length);
                    setPageSize(res.data?.meta.totalPages);
                })
                .catch((e) => {
                    console.log(e);
                });
        } else if (tabs === "Inventory finance") {
            await axios
                .get(
                    `/v1/admin/finance/all?page=${currentPageInventory}&financeType=inventory_finance&limit=20`
                )
                .then((res) => {
                    setstat(res.data.data);
                    setInventoryFinance(res.data.data);
                    setTotalCountInventory(res.data?.meta.totalItems);
                    setPageSize(res.data?.meta.totalPages);
                })
                .catch((e) => {
                    console.log(e);
                });
        } else if (tabs === "Receivables finance") {
            await axios
                .get(`/v1/admin/finance/all?page=${currentPageTrade}&financeType=receivable_finance`)
              .then((res) => {
                console.log({ res }, '=== response receivable finance')
                    setstat(res.data.data);
                    setReceivableFinance(res.data.data);
                    setTotalCountReceivable(res.meta.totalItems || res.data.data.length);
                })
                .catch((e) => {
                    console.log(e);
                });
        } else if (tabs === "Payment finance") {
          await axios
            .get(`/v1/admin/finance/all?page=${currentPagePayment}&financeType=payment_finance`)
            .then((res) => {
              setstat(res?.data?.data);
              setPaymentFinanceNew(res?.data?.data);
              setTotalCountPayment(res?.data?.meta?.totalPages || res?.data?.data?.length);
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
            console.log("error");
        }
    };

    useEffect(() => {
        setCurrentPageFactoring(1);
        setCurrentPageCredit(1);
        setCurrentPageTrade(1);
        setCurrentPageInventory(1);
    }, [search, selectedstatus, selectedrequest, selectedsort]);

    const handleTabChange = (newTab) => {
        settab(newTab);
        localStorage.setItem("activeTab", newTab);

        setCurrentPageFactoring(1);
        setCurrentPageCredit(1);
        setCurrentPageTrade(1);
        setCurrentPageInventory(1);
        setPayableFinanceCurrentPage(1);
        setReceivableFinanceCurrentPage(1);
        setInventoryCurrentPage(1);
        setPaymentRequestCurrentPage(1)
        setSearch("")
    };
    useEffect(() => {
        const savedTab = localStorage.getItem("activeTab");
        if (savedTab) {
            settab(savedTab);
        } else {
            settab("Payments");
        }

        return () => {
            if (!location.pathname.startsWith("/finance")) {
                localStorage.removeItem("activeTab");
            }
        };
    }, [location.pathname]);

    useEffect(() => {
        if (location.pathname.startsWith("/finance")) {
            localStorage.setItem("activeTab", tab);
        }
    }, [tab, location.pathname]);

    const sorting = (col, index) => {
        setselectedIndex(index);

        const sortData = (dataArray, setDataFunction) => {
            const sorted = [...dataArray]?.sort((a, b) => {
                let aValue, bValue;

                if (col.includes(".")) {
                    const keys = col.split(".");
                    aValue = keys.reduce((obj, key) => obj?.[key], a) || "";
                    bValue = keys.reduce((obj, key) => obj?.[key], b) || "";
                } else {
                    aValue = a[col] || "";
                    bValue = b[col] || "";
                }

                // Convert to string for comparison
                aValue = aValue.toString().toLowerCase();
                bValue = bValue.toString().toLowerCase();

                if (order === "ASC") {
                    return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
                } else {
                    return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
                }
            });

            setDataFunction(sorted);
        };

        switch (tab) {
            case "Payments":
                sortData(data, setData);
                break;
            case "payable finance":
                sortData(payableFinance, setPayableFinance);
                break;
            case "Receivables finance":
                sortData(receivableFinance, setReceivableFinance);
                break;
            case "Inventory finance":
                sortData(inventoryFinance, setInventoryFinance);
                break;
          case "Payment finance":
            sortData(paymentFinanceNew, setPaymentFinanceNew);
            break;
        }

        setOrder(order === "ASC" ? "DSC" : "ASC");
    };
    const debouncedSetSearch = debounce((value) => setSearch(value), 500);
    const handleClearFilter = () => {
        setPaymentRequestCurrentPage(1)
        setselectedindexstatus(0);
        setselectedstatus("All");
        setselectedIndex(0);
        setSearch("");
        setselectedsort("Recent");
    };

    return (
        <>
        <div className="">
                <OtherHeader title={"Finance"} />
                <div className="info-cl">
                    <div
                        className="mt-3 overview"
                        style={{
                            justifyContent: "space-between",
                            alignItems: "center",
                            display: "flex",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                alignItems: "center",
                                width: "80%",
                            }}
                        >
                            <h4
                                style={{
                                    margin: "0px",
                                    padding: "0px",
                                }}
                            >
                                Overview
                            </h4>
                            <div
                                className="drop-stat"
                                style={{
                                    width: "100%",
                                    maxWidth: "150px",
                                    position: "relative",
                                }}
                            >
                                <span className="all-time">All time</span>
                                <img src={angledown || "/placeholder.svg"} alt="" />
                            </div>
                        </div>

                        <div
                            className="drop-stat"
                            style={{
                                width: "100%",
                                maxWidth: "150px",
                                position: "relative",
                                cursor: "pointer",
                                padding: "8px",
                                borderRadius: "30px",
                                border: "1px solid #D0D5DD",
                                display: "flex",
                                justifyContent: "center",
                            }}
                            onClick={() => setisdrop(!isdrop)}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                }}
                            >
                                <img
                                    src={currencciess[defaultcur].img || "/placeholder.svg"}
                                    alt=""
                                    style={{
                                        width: "20px",
                                    }}
                                />

                                <span
                                    className="all-time"
                                    style={{
                                        color: "#101828",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        lineHeight: "19.6px",
                                    }}
                                >
                                    {currencciess[defaultcur].title}
                                </span>
                            </div>
                            {isdrop && (
                                <div className="drop_filter_currency">
                                    <div
                                        style={{
                                            padding: "0px 16px ",
                                            display: "flex",
                                            gap: "8px",
                                            flexDirection: "column",
                                        }}
                                    >
                                        {currencciess.map((res, index) => (
                                            <div
                                                key={index}
                                                className="fill-left-currency"
                                                style={{
                                                    cursor: "pointer",
                                                    padding: "8px",
                                                    background: defaultcur === index && " #F4F0FF",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    borderRadius: "8px",
                                                }}
                                                onClick={() => {
                                                    setdefault(index);
                                                    setisdrop(false);
                                                    searchStat(currencciess[index].name, tab);
                                                    setcur(currencciess[index].name);
                                                    setselectedcurindex(index);
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                    }}
                                                >
                                                    <img
                                                        src={res.img || "/placeholder.svg"}
                                                        alt=""
                                                        style={{ width: "25px" }}
                                                    />
                                                    <div
                                                        style={{
                                                            display: "grid",
                                                        }}
                                                    >
                                                        <span className="name_cur">{res.title}</span>
                                                        <span
                                                            style={{
                                                                fontWeight: "400",
                                                                fontSize: "12px",
                                                                lineHeight: "16.2px",
                                                                letterSpacing: "2%",
                                                                color: "#667085",
                                                            }}
                                                        >
                                                            {res.name}
                                                        </span>
                                                    </div>
                                                </div>
                                                {defaultcur === index && (
                                                    <img src={successmark || "/placeholder.svg"} alt="" />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <span className="material-icons">expand_more</span>
                        </div>
                    </div>

                    <div className="each-card">
                        <div className="main-card-each">
                            <div className="innercard">
                                <h5>total requested amount</h5>
                                <div className="stat-line">
                                    <span>
                                        {currencyPairCheck(currencciess[defaultcur].name)}
                                        {AmountCheck(overviewData?.totalRequestedAmount?.value)}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="main-card-each">
                            <div className="innercard">
                                <h5>paid out</h5>
                                <div className="stat-line">
                                    <span>
                                        {currencyPairCheck(currencciess[defaultcur].name)}
                                        {AmountCheck(overviewData?.paidOut?.value)}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="main-card-each">
                            <div className="innercard">
                                <h5>Pending</h5>
                                <div className="stat-line">
                                    <span>
                                        {" "}
                                        {currencyPairCheck(currencciess[defaultcur].name)}
                                        {AmountCheck(overviewData?.pendingDisbursal?.value)}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="info-cl2">
                    <ul className="tp-head-list">
                        <li
                            onClick={() => {
                                handleTabChange("Payments");
                                handleClearFilter()
                                searchStat(currencciess[defaultcur].name, "Payments");
                            }}
                            style={{
                                borderBottom: tab === "Payments" ? "3px solid #6F00FF" : "",
                            }}
                        >
                            Payment Request
                        </li>
                        <li
                            onClick={() => {
                                handleTabChange("Payable finance");
                                handleClearFilter()
                                searchStat(currencciess[defaultcur].name, "Payable finance");
                            }}
                            style={{
                                borderBottom: tab === "Payable finance" ? "3px solid #6F00FF" : "",
                            }}
                        >
                            Payables finance
                        </li>
                        <li
                            onClick={() => {
                                handleTabChange("Receivables finance");
                                handleClearFilter()
                                searchStat(currencciess[defaultcur].name, "Receivables finance");
                            }}
                            style={{
                                borderBottom: tab === "Receivables finance" ? "3px solid #6F00FF" : "",
                            }}
                        >
                            Receivables finance
                        </li>
              {/* <li
                            onClick={() => {
                                handleTabChange("Inventory finance");
                                handleClearFilter()
                                searchStat(currencciess[defaultcur].name, "Inventory finance");
                            }}
                            style={{
                                borderBottom: tab === "Inventory finance" ? "3px solid #6F00FF" : "",
                            }}
                        >
                            Inventory finance
                        </li> */}
              <li
                onClick={() => {
                  handleTabChange("Payment finance");
                  handleClearFilter()
                  searchStat(currencciess[defaultcur].name, "Payment finance");
                }}
                style={{
                  borderBottom: tab === "Payment finance" ? "3px solid #6F00FF" : "",
                }}
              >
                Payment finance
              </li>
                    </ul>

                    {/* Factoring Tabs */}
                    {tab === "Payments" && (
                        <div className="lg-card">
                            <div
                                className="md-cl"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <div className="search-dl">
                                    <div
                                        className="search-l flex gap-[6px] items-center py-[10px] px-[14px] bg-[#ECEFF3] rounded-[8px] w-[320px]"
                                    >
                                        <img src={sech || "/placeholder.svg"} alt="" />
                                        <input
                                            type="text"
                                            placeholder="Search by customer name"
                                            defaultValue={search}
                                            onChange={(e) => {
                                                debouncedSetSearch(e.target.value)
                                            }}
                                            className="outline-none border-none bg-[#ECEFF3] w-full h-[30px]"
                                        />
                                    </div>
                                </div>
                                <div className="search-ls">
                                    <div className="eacl-lft-filter" onClick={() => setisSort(!isSort)}>
                                        {isSort && (
                                            <div className="fixed-fliterbox">
                                                <div className="inner_fixed_col">
                                                    <div className="main_fix_filter">
                                                        {sort.map((statuss, index) => (
                                                            <div
                                                                className="filter_each_none"
                                                                style={{
                                                                    background: selectedindexsort === index ? "#F4F0FF" : "",
                                                                    borderRadius: "8px",
                                                                }}
                                                                key={index}
                                                                onClick={() => {
                                                                    setselectedindexsort(index);
                                                                    setselectedsort(statuss);
                                                                    setisSort(false);
                                                                }}
                                                            >
                                                                <span> {statuss} </span>
                                                                {selectedindexsort === index && (
                                                                    <>
                                                                        <img src={mark || "/placeholder.svg"} alt="" />
                                                                    </>
                                                                )}{" "}
                                                            </div>
                                                        ))}{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <span className="type">Sort </span>

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "2px",
                                                color: "#344054",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                                lineHeight: "19.6px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {selectedsort}
                                            <span className="material-icons">expand_more</span>
                                        </div>
                                    </div>
                                    <div className="eacl-lft-filter" onClick={() => setisRequest(!isRequest)}>
                                        {isRequest && (
                                            <div className="fixed-fliterbox">
                                                <div className="inner_fixed_col">
                                                    <div className="main_fix_filter">
                                                        {requestType.map((statuss, index) => (
                                                            <div
                                                                className="filter_each_none"
                                                                style={{
                                                                    background: selectedindexrequest === index ? "#F4F0FF" : "",
                                                                    borderRadius: "8px",
                                                                }}
                                                                key={index}
                                                                onClick={() => {
                                                                    setselectedindexrequest(index);
                                                                    setselectedrequest(statuss);
                                                                }}
                                                            >
                                                                <span> {statuss} </span>
                                                                {selectedindexrequest === index && (
                                                                    <>
                                                                        <img src={mark || "/placeholder.svg"} alt="" />
                                                                    </>
                                                                )}{" "}
                                                            </div>
                                                        ))}{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <span className="type">Request type </span>

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "2px",
                                                color: "#344054",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                                lineHeight: "19.6px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {selectedrequest}
                                            <span className="material-icons">expand_more</span>
                                        </div>
                                    </div>

                                    <div className="eacl-lft-filter" onClick={() => setisStatus(!isStatus)}>
                                        {isStatus && (
                                            <div className="fixed-fliterbox">
                                                <div className="inner_fixed_col">
                                                    <div className="main_fix_filter">
                                                        {paymentRequestStatus.map((statuss, index) => (
                                                            <div
                                                                className="filter_each_none"
                                                                style={{
                                                                    background: selectedindexstatus === index ? "#F4F0FF" : "",
                                                                    borderRadius: "8px",
                                                                }}
                                                                key={index}
                                                                onClick={() => {
                                                                    setselectedindexstatus(index);
                                                                    setselectedstatus(statuss);
                                                                }}
                                                            >
                                                                <span> {statuss} </span>
                                                                {selectedindexstatus === index && (
                                                                    <>
                                                                        <img src={mark || "/placeholder.svg"} alt="" />
                                                                    </>
                                                                )}{" "}
                                                            </div>
                                                        ))}{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <span className="type">Status :</span>

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "2px",
                                                color: "#344054",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                                lineHeight: "19.6px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {selectedstatus}
                                            <span className="material-icons">expand_more</span>
                                        </div>
                                    </div>
                                    <div className="eacl-lft-filter">
                                        <span
                                            className="type text-[#98A2B3] font-[400] text-sm cursor-pointer"
                                            onClick={() => handleClearFilter()}
                                        >
                                            Clear filter
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {isloading ? (
                                <div className="loadingdata">
                                    {" "}
                                    <LoaderDate />{" "}
                                </div>
                            ) : (
                                    <div style={{ overflow: "auto" }}>
                                        <table className="table row-datatable">
                                            <thead className="table-head">
                                                <tr>
                                                    <th onClick={() => sorting("Date Requested", 0)}>
                                                        Date Requested
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 0 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 0 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <th onClick={() => sorting("customer name", 1)}>
                                                        Customer name
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 1 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 1 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <th onClick={() => sorting("email", 2)}>
                                                        Amount
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 1 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 1 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>

                                                    <th onClick={() => sorting("createdAt", 9)}>
                                                        Type
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 3 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 3 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>

                                                    <th onClick={() => sorting("status", 5)}>
                                                        Status{" "}
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 5 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 5 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-head" style={{ width: "100%" }}>
                                                {currentTableData?.map((user, index) => {
                                                    return (
                                                        <tr
                                                            key={index}
                                                            className="each_row"
                                                            onClick={() => goToDetails(user, "Payments")}
                                                        >
                                                            <td
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "8px",
                                                                }}
                                                            >
                                                                <div>
                                                                    {" "}
                                                                    {new Date(user.createdAt).toDateString()}{" "}
                                                                    {new Date(user.createdAt).toLocaleTimeString()}{" "}
                                                                </div>
                                                            </td>
                                                            <td
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "8px",
                                                                }}
                                                            >
                                                                <div className="flex items-center gap-2 overflow-hidden truncate">
                                                                    <span className="inline-flex profile-d-icon">
                                                                        {user?.business?.name?.slice(0, 2)}
                                                                    </span>
                                                                    <p className="w-11/12 overflow-hidden truncate">
                                                                        {user?.business?.name}
                                                                    </p>
                                                                </div>
                                                            </td>

                                                            <td> {user?.amount} </td>

                                                            <td>
                                                                <div>{user?.paymentType}</div>
                                                            </td>
                                                            <td
                                                                style={{
                                                                    color: statusColors[user?.status],
                                                                }}
                                                            >
                                                                {user?.status}{" "}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>

                                        <div className="page-container">
                                            <PaginationV2
                                                gotoNext={() => {
                                                    if (paymentRequestCurrentPage === PageSize) {
                                                        return;
                                                    }
                                                    setPaymentRequestCurrentPage((page) => page + 1);
                                                }}
                                                gotoPrev={() => {
                                                    if (paymentRequestCurrentPage === 1) {
                                                        return;
                                                    }
                                                    setPaymentRequestCurrentPage((page) => page - 1);
                                                }}
                                                gotoPage={(page) => setPaymentRequestCurrentPage(page)}
                                                paginationData={paginationData(PageSize)}
                                                activePage={paymentRequestCurrentPage}
                                            />
                                        </div>
                                    </div>
                            )}
                        </div>
                    )}{" "}
                    {/* Payable Tabs */}
                    {tab === "Payable finance" && (
                        <div className="lg-card">
                            <div
                                className="md-cl"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="w-full search-dl"
                                >
                                    <div
                                        className="search-l flex gap-[6px] items-center py-[10px] px-[14px] bg-[#ECEFF3] rounded-[8px] w-[320px]"
                                    >
                                        <img src={sech || "/placeholder.svg"} alt="" />
                                        <input
                                            type="text"
                                            placeholder="Search by customer name"
                                            defaultValue={search}
                                            onChange={(e) => {
                                                debouncedSetSearch(e.target.value)
                                            }}
                                            className="outline-none border-none bg-[#ECEFF3] w-full h-[30px]"
                                        />
                                    </div>
                                </div>
                                <div className="search-ls">
                                    <div className="eacl-lft-filter" onClick={() => setisSort(!isSort)}>
                                        {isSort && (
                                            <div className="fixed-fliterbox">
                                                <div className="inner_fixed_col">
                                                    <div className="main_fix_filter">
                                                        {sort.map((statuss, index) => (
                                                            <div
                                                                className="filter_each_none"
                                                                style={{
                                                                    background: selectedindexsort === index ? "#F4F0FF" : "",
                                                                    borderRadius: "8px",
                                                                }}
                                                                key={index}
                                                                onClick={() => {
                                                                    setselectedindexsort(index);
                                                                    setselectedsort(statuss);
                                                                    setisSort(false); // Close dropdown after selection
                                                                }}
                                                            >
                                                                <span> {statuss} </span>
                                                                {selectedindexsort === index && (
                                                                    <>
                                                                        <img src={mark || "/placeholder.svg"} alt="" />
                                                                    </>
                                                                )}{" "}
                                                            </div>
                                                        ))}{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <span className="type">Sort </span>

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "2px",
                                                color: "#344054",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                                lineHeight: "19.6px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {selectedsort}
                                            <span className="material-icons">expand_more</span>
                                        </div>
                                    </div>

                                    <div className="eacl-lft-filter" onClick={() => setisStatus(!isStatus)}>
                                        {isStatus && (
                                            <div className="fixed-fliterbox">
                                                <div className="inner_fixed_col">
                                                    <div className="main_fix_filter">
                                                        {status.map((statuss, index) => (
                                                            <div
                                                                className="filter_each_none"
                                                                style={{
                                                                    background: selectedindexstatus === index ? "#F4F0FF" : "",
                                                                    borderRadius: "8px",
                                                                }}
                                                                key={index}
                                                                onClick={() => {
                                                                    setselectedindexstatus(index);
                                                                    setselectedstatus(statuss);
                                                                }}
                                                            >
                                                                <span> {statuss} </span>
                                                                {selectedindexstatus === index && (
                                                                    <>
                                                                        <img src={mark || "/placeholder.svg"} alt="" />
                                                                    </>
                                                                )}{" "}
                                                            </div>
                                                        ))}{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <span className="type">Status :</span>

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "2px",
                                                color: "#344054",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                                lineHeight: "19.6px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {selectedstatus}
                                            <span className="material-icons">expand_more</span>
                                        </div>
                                    </div>
                                    <div className="eacl-lft-filter">
                                        <span
                                            className="type text-[#98A2B3] font-[400] text-sm cursor-pointer"
                                            onClick={() => handleClearFilter()}
                                        >
                                            Clear filter
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {isloading ? (
                                <div className="loadingdata" >
                                    < LoaderDate />
                                </div>
                            ) : (
                                    <div style={{ overflow: "auto" }}>
                                        <table className="table row-datatable">
                                            <thead className="table-head">
                                                <tr>
                                                    <th className="text-center" onClick={() => sorting("user['firstName']", 0)}>
                                                        Name
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 0 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 0 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <th className="text-center" onClick={() => sorting("phoneNumber", 2)}>
                                                        <div className="flex items-center justify-center w-full">
                                                        Amount{" "}
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 2 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 2 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                        </div>
                                                    </th>
                                                    <th onClick={() => sorting("createdAt", 9)}>
                                                        <div className="flex items-center justify-center w-full">
                                                        Date
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 3 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 3 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                        </div>
                                                    </th>

                                                    <th>
                                                        <div className="flex items-center justify-center w-full">
                                                        Tenure{" "}
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                        </div>
                                                    </th>
                                                    <th onClick={() => sorting("status", 5)}>
                                                        <div className="flex items-center justify-center w-full">
                                                        Status{" "}
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 5 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 5 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                        </div>
                                                    </th>

                                                    <th
                                                        style={{
                                                            opacity: "0",
                                                            visibility: "0",
                                                        }}
                                                    >
                                                        <div className="flex items-center justify-center w-full">  
                                                        Status{" "}
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            {currentTableDataPayableFinance?.length > 0 && (
                                                <tbody className="table-head" style={{ width: "100%" }}>
                                                    {currentTableDataPayableFinance?.map((user, index) => (
                                                        <tr
                                                            key={index}
                                                            className="each_row"
                                                            onClick={() => goToDetails(user, "Payables finance")}
                                                        >
                                                            <td
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "8px",
                                                                }}
                                                            >
                                                                <div className="profile-d-icon">
                                                                    {user?.business?.name?.slice(0, 2)}
                                                                </div>
                                                                <div className="name-avater-tag">
                                                                    <span> {user?.business?.name} </span>
                                                                    <span className="business_name">
                                                                        {user.business?.user?.firstName} {user.business?.user?.lastName}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {" "}
                                                                {currencyPairCheck(user.currency)}
                                                                {AmountCheck(user.requestedAmount)}{" "}
                                                            </td>
                                                            {/* <td>{user._id}</td> */}
                                                            <td>
                                                                {" "}
                                                                {new Date(user.createdAt).toDateString()}{" "}
                                                                {new Date(user.createdAt).toLocaleTimeString()}{" "}
                                                            </td>

                                                            <td>{user?.tenure} Days</td>
                                                            <td
                                                                style={{
                                                                    color: statusColors[user?.status],
                                                                }}
                                                            >
                                                                {user.status}{" "}
                                                            </td>

                                                            {/* <td
                            className="view_account"
                            onClick={() =>
                              goToDetails(user, "Payables finance")
                            }
                          >
                            View
                          </td> */}
                                                        </tr>
                                                    ))}{" "}
                                                </tbody>
                                            )}
                                            {currentTableDataPayableFinance?.length === 0 && (
                                                <div className="empty_lg">
                                                    <img src={empty || "/placeholder.svg"} alt="" />
                                                    <div className="bg_lg_dm">
                                                        <h4>No Finance Transaction</h4>
                                                        <span>Finance will show here.</span>
                                                    </div>
                                                </div>
                                            )}
                                        </table>

                                        <div className="page-container">
                                            <PaginationV2
                                                gotoNext={() => {
                                                    if (payableFinanceCurrentPage === payableFinancePageSize) {
                                                        return;
                                                    }
                                                    setPayableFinanceCurrentPage((page) => page + 1);
                                                }}
                                                gotoPrev={() => {
                                                    if (payableFinanceCurrentPage === 1) {
                                                        return;
                                                    }
                                                    setPayableFinanceCurrentPage((page) => page - 1);
                                                }}
                                                gotoPage={(page) => setPayableFinanceCurrentPage(page)}
                                                paginationData={paginationData(payableFinancePageSize)}
                                                activePage={payableFinanceCurrentPage}
                                            />
                                        </div>
                                    </div>
                            )}
                        </div>
                    )}{" "}
                    {/* Receivable Tabs */}
                    {tab === "Receivables finance" && (
                        <div className="lg-card">
                            <div
                                className="md-cl"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="search-dl"
                                    style={{
                                        width: "100%",
                                    }}
                                >
                                    <div
                                        className="search-l flex gap-[6px] items-center py-[10px] px-[14px] bg-[#ECEFF3] rounded-[8px] w-[320px]"
                                    >
                                        <img src={sech || "/placeholder.svg"} alt="" />
                                        <input
                                            type="text"
                                            placeholder="Search by customer name"
                                            defaultValue={search}
                                            onChange={(e) => {
                                                debouncedSetSearch(e.target.value)
                                            }}
                                            className="outline-none border-none bg-[#ECEFF3] w-full h-[30px]"
                                        />
                                    </div>
                                </div>
                                <div className="search-ls">
                                    <div className="eacl-lft-filter" onClick={() => setisSort(!isSort)}>
                                        {isSort && (
                                            <div className="fixed-fliterbox">
                                                <div className="inner_fixed_col">
                                                    <div className="main_fix_filter">
                                                        {sort.map((statuss, index) => (
                                                            <div
                                                                className="filter_each_none"
                                                                style={{
                                                                    background: selectedindexsort === index ? "#F4F0FF" : "",
                                                                    borderRadius: "8px",
                                                                }}
                                                                key={index}
                                                                onClick={() => {
                                                                    setselectedindexsort(index);
                                                                    setselectedsort(statuss);
                                                                    setisSort(false);
                                                                }}
                                                            >
                                                                <span> {statuss} </span>
                                                                {selectedindexsort === index && (
                                                                    <>
                                                                        <img src={mark || "/placeholder.svg"} alt="" />
                                                                    </>
                                                                )}{" "}
                                                            </div>
                                                        ))}{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <span className="type">Sort </span>

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "2px",
                                                color: "#344054",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                                lineHeight: "19.6px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {selectedsort}
                                            <span className="material-icons">expand_more</span>
                                        </div>
                                    </div>

                                    <div className="eacl-lft-filter" onClick={() => setisStatus(!isStatus)}>
                                        {isStatus && (
                                            <div className="fixed-fliterbox">
                                                <div className="inner_fixed_col">
                                                    <div className="main_fix_filter">
                                                        {status.map((statuss, index) => (
                                                            <div
                                                                className="filter_each_none"
                                                                style={{
                                                                    background: selectedindexstatus === index ? "#F4F0FF" : "",
                                                                    borderRadius: "8px",
                                                                }}
                                                                key={index}
                                                                onClick={() => {
                                                                    setselectedindexstatus(index);
                                                                    setselectedstatus(statuss);
                                                                }}
                                                            >
                                                                <span> {statuss} </span>
                                                                {selectedindexstatus === index && (
                                                                    <>
                                                                        <img src={mark || "/placeholder.svg"} alt="" />
                                                                    </>
                                                                )}{" "}
                                                            </div>
                                                        ))}{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <span className="type">Status :</span>

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "2px",
                                                color: "#344054",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                                lineHeight: "19.6px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {selectedstatus}
                                            <span className="material-icons">expand_more</span>
                                        </div>
                                    </div>
                                    <div className="eacl-lft-filter">
                                        <span
                                            className="type text-[#98A2B3] font-[400] text-sm cursor-pointer"
                                            onClick={() => handleClearFilter()}
                                        >
                                            Clear filter
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {isloading ? (
                                <div className="loadingdata" >
                                    < LoaderDate />
                                </div>
                            ) : (
                                    <div style={{ overflow: "auto" }}>
                                        <table className="table row-datatable">
                                            <thead className="table-head">
                                                <tr>
                                                    <th onClick={() => sorting("user['firstName']", 0)}>
                                                        Name
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 0 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 0 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <th onClick={() => sorting("email", 1)}>
                                                        {/* Email address{" "} */}
                                                        <div className="sort_icon-con">
                                                            {/* <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 1 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 1 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span> */}
                                                        </div>
                                                    </th>
                                                    <th onClick={() => sorting("phoneNumber", 2)}>
                                                        Amount{" "}
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 2 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 2 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>
                                                    {/* <th onClick={() => sorting("phoneNumber", 2)}>
                        ID{" "}
                        <div className="sort_icon-con">
                          <span
                            className="material-icons up-arrwo"
                            style={{
                              color:
                                order === "ASC" && selectedIndex === 2
                                  ? "#873BFF"
                                  : "#667085",
                            }}
                          >
                            arrow_drop_up
                          </span>

                          <span
                            className="material-icons down-arrow"
                            style={{
                              color:
                                order === "DSC" && selectedIndex === 2
                                  ? "#873BFF"
                                  : "#667085",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        </div>
                      </th> */}

                                                    <th onClick={() => sorting("createdAt", 9)}>
                                                        Date
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 3 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 3 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>

                                                    {/* <th onClick={() => sorting("country", 4)}>
                        End Customer{" "}
                        <div className="sort_icon-con">
                          <span
                            className="material-icons up-arrwo"
                            style={{
                              color:
                                order === "ASC" && selectedIndex === 4
                                  ? "#873BFF"
                                  : "#667085",
                            }}
                          >
                            arrow_drop_up
                          </span>

                          <span
                            className="material-icons down-arrow"
                            style={{
                              color:
                                order === "DSC" && selectedIndex === 4
                                  ? "#873BFF"
                                  : "#667085",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        </div>
                      </th> */}
                                                    {/* <th>
                        Tenure{" "}
                        <div className="sort_icon-con">
                          <span
                            className="material-icons up-arrwo"
                            style={{
                              color: order === "ASC" ? "#873BFF" : "#667085",
                            }}
                          >
                            arrow_drop_up
                          </span>

                          <span
                            className="material-icons down-arrow"
                            style={{
                              color: order === "DSC" ? "#873BFF" : "#667085",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        </div>
                      </th> */}
                                                    <th onClick={() => sorting("status", 5)}>
                                                        Status{" "}
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 5 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 5 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>

                                                    {/* <th
                        style={{
                          opacity: "0",
                          visibility: "0",
                        }}
                      >
                        Status{" "}
                        <div className="sort_icon-con">
                          <span
                            className="material-icons up-arrwo"
                            style={{
                              color: order === "ASC" ? "#873BFF" : "#667085",
                            }}
                          >
                            arrow_drop_up
                          </span>

                          <span
                            className="material-icons down-arrow"
                            style={{
                              color: order === "DSC" ? "#873BFF" : "#667085",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        </div>
                      </th> */}
                          </tr>
                        </thead>
                        {currentTableDataReceivableFinance.length > 0 && (
                          <tbody className="table-head" style={{ width: "100%" }}>
                            {currentTableDataReceivableFinance?.map((user, index) => (
                              <tr
                                key={index}
                                className="each_row"
                                onClick={() => goToDetails(user, "Receivables finance")}
                              >
                                <td
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <div className="profile-d-icon">
                                    {user?.business?.name?.slice(0, 2)}
                                  </div>
                                  <div className="name-avater-tag">
                                    <span> {user?.business?.name} </span>
                                    <span className="business_name">
                                      {user?.business?.user?.firstName} {user?.business?.user?.lastName}
                                    </span>
                                  </div>
                                </td>

                                <td> {user?.user?.email} </td>

                                <td>
                                  {" "}
                                  {currencyPairCheck(user.currency)}
                                  {AmountCheck(user.requestedAmount)}{" "}
                                </td>
                                {/* <td>{user._id}</td> */}
                                <td>
                                  {" "}
                                  {new Date(user.createdAt).toDateString()}{" "}
                                  {new Date(user.createdAt).toLocaleTimeString()}{" "}
                                </td>
                                {/* <td> {user?.businessName}</td> */}
                                {/* <td>{user.tenure} Days</td> */}
                                <td
                                  style={{
                                    color: statusColors[user?.status],
                                  }}
                                >
                                  {user.status}{" "}
                                </td>

                                {/* <td
                            className="view_account"
                            onClick={() =>
                              goToDetails(user, "Receivables finance")
                            }
                          >
                            View
                          </td> */}
                              </tr>
                            ))}
                        </tbody>
                      )}{" "}
                      {currentTableDataReceivableFinance.length === 0 && (
                        <div className="empty_lg">
                          <img src={empty || "/placeholder.svg"} alt="" />
                          <div className="bg_lg_dm">
                            <h4>No Trade credit Transaction</h4>
                            <span>Finance will show here.</span>
                          </div>
                        </div>
                      )}
                    </table>

                    <div className="page-container">
                      <PaginationV2
                        gotoNext={() => {
                          if (receivableFinanceCurrentPage === receivableFinancePageSize) {
                            return;
                          }
                          setReceivableFinanceCurrentPage((page) => page + 1);
                        }}
                        gotoPrev={() => {
                          if (receivableFinanceCurrentPage === 1) {
                            return;
                          }
                          setReceivableFinanceCurrentPage((page) => page - 1);
                        }}
                        gotoPage={(page) => setReceivableFinanceCurrentPage(page)}
                        paginationData={paginationData(receivableFinancePageSize)}
                        activePage={receivableFinanceCurrentPage}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
            {tab === "Payment finance" && (
              <div className="lg-card">
                <div
                  className="md-cl"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="search-dl"
                    style={{
                      width: "100%",
                    }}
                  >
                    <div
                      className="search-l flex gap-[6px] items-center py-[10px] px-[14px] bg-[#ECEFF3] rounded-[8px] w-[320px]"
                    >
                      <img src={sech || "/placeholder.svg"} alt="" />
                      <input
                        type="text"
                        placeholder="Search by customer name"
                        defaultValue={search}
                        onChange={(e) => {
                          debouncedSetSearch(e.target.value)
                        }}
                        className="outline-none border-none bg-[#ECEFF3] w-full h-[30px]"
                      />
                    </div>
                  </div>
                  <div className="search-ls">
                    <div className="eacl-lft-filter" onClick={() => setisSort(!isSort)}>
                      {isSort && (
                        <div className="fixed-fliterbox">
                          <div className="inner_fixed_col">
                            <div className="main_fix_filter">
                              {sort.map((statuss, index) => (
                                <div
                                  className="filter_each_none"
                                  style={{
                                    background: selectedindexsort === index ? "#F4F0FF" : "",
                                    borderRadius: "8px",
                                  }}
                                  key={index}
                                  onClick={() => {
                                    setselectedindexsort(index);
                                    setselectedsort(statuss);
                                    setisSort(false);
                                  }}
                                >
                                  <span> {statuss} </span>
                                  {selectedindexsort === index && (
                                    <>
                                      <img src={mark || "/placeholder.svg"} alt="" />
                                    </>
                                  )}{" "}
                                </div>
                              ))}{" "}
                            </div>
                          </div>
                        </div>
                      )}

                      <span className="type">Sort </span>

                      <div
                        style={{
                          display: "flex",
                          gap: "2px",
                          color: "#344054",
                          fontWeight: "500",
                          fontSize: "14px",
                          lineHeight: "19.6px",
                          alignItems: "center",
                        }}
                      >
                        {selectedsort}
                        <span className="material-icons">expand_more</span>
                      </div>
                    </div>

                    <div className="eacl-lft-filter" onClick={() => setisStatus(!isStatus)}>
                      {isStatus && (
                        <div className="fixed-fliterbox">
                          <div className="inner_fixed_col">
                            <div className="main_fix_filter">
                              {status.map((statuss, index) => (
                                <div
                                  className="filter_each_none"
                                  style={{
                                    background: selectedindexstatus === index ? "#F4F0FF" : "",
                                    borderRadius: "8px",
                                  }}
                                  key={index}
                                  onClick={() => {
                                    setselectedindexstatus(index);
                                    setselectedstatus(statuss);
                                  }}
                                >
                                  <span> {statuss} </span>
                                  {selectedindexstatus === index && (
                                    <>
                                      <img src={mark || "/placeholder.svg"} alt="" />
                                    </>
                                  )}{" "}
                                </div>
                              ))}{" "}
                            </div>
                          </div>
                        </div>
                      )}

                      <span className="type">Status :</span>

                      <div
                        style={{
                          display: "flex",
                          gap: "2px",
                          color: "#344054",
                          fontWeight: "500",
                          fontSize: "14px",
                          lineHeight: "19.6px",
                          alignItems: "center",
                        }}
                      >
                        {selectedstatus}
                        <span className="material-icons">expand_more</span>
                      </div>
                    </div>
                    <div className="eacl-lft-filter">
                      <span
                        className="type text-[#98A2B3] font-[400] text-sm cursor-pointer"
                        onClick={() => handleClearFilter()}
                      >
                        Clear filter
                      </span>
                    </div>
                  </div>
                </div>

                {isloading ? (
                  <div className="loadingdata" >
                    < LoaderDate />
                  </div>
                ) : (
                  <div style={{ overflow: "auto" }}>
                    <table className="table row-datatable">
                      <thead className="table-head">
                        <tr>
                          <th onClick={() => sorting("user['firstName']", 0)}>
                            Name
                            <div className="sort_icon-con">
                              <span
                                className="material-icons up-arrwo"
                                style={{
                                  color: order === "ASC" && selectedIndex === 0 ? "#873BFF" : "#667085",
                                }}
                              >
                                arrow_drop_up
                              </span>

                              <span
                                className="material-icons down-arrow"
                                style={{
                                  color: order === "DSC" && selectedIndex === 0 ? "#873BFF" : "#667085",
                                }}
                              >
                                arrow_drop_down
                              </span>
                            </div>
                          </th>
                          <th onClick={() => sorting("email", 1)}>
                            {/* Email address{" "} */}
                            <div className="sort_icon-con">
                              {/* <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 1 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 1 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span> */}
                            </div>
                          </th>
                          <th onClick={() => sorting("phoneNumber", 2)}>
                            Amount{" "}
                            <div className="sort_icon-con">
                              <span
                                className="material-icons up-arrwo"
                                style={{
                                  color: order === "ASC" && selectedIndex === 2 ? "#873BFF" : "#667085",
                                }}
                              >
                                arrow_drop_up
                              </span>

                              <span
                                className="material-icons down-arrow"
                                style={{
                                  color: order === "DSC" && selectedIndex === 2 ? "#873BFF" : "#667085",
                                }}
                              >
                                arrow_drop_down
                              </span>
                            </div>
                          </th>
                          {/* <th onClick={() => sorting("phoneNumber", 2)}>
                        ID{" "}
                        <div className="sort_icon-con">
                          <span
                            className="material-icons up-arrwo"
                            style={{
                              color:
                                order === "ASC" && selectedIndex === 2
                                  ? "#873BFF"
                                  : "#667085",
                            }}
                          >
                            arrow_drop_up
                          </span>

                          <span
                            className="material-icons down-arrow"
                            style={{
                              color:
                                order === "DSC" && selectedIndex === 2
                                  ? "#873BFF"
                                  : "#667085",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        </div>
                      </th> */}

                          <th onClick={() => sorting("createdAt", 9)}>
                            Date
                            <div className="sort_icon-con">
                              <span
                                className="material-icons up-arrwo"
                                style={{
                                  color: order === "ASC" && selectedIndex === 3 ? "#873BFF" : "#667085",
                                }}
                              >
                                arrow_drop_up
                              </span>

                              <span
                                className="material-icons down-arrow"
                                style={{
                                  color: order === "DSC" && selectedIndex === 3 ? "#873BFF" : "#667085",
                                }}
                              >
                                arrow_drop_down
                              </span>
                            </div>
                          </th>

                          {/* <th onClick={() => sorting("country", 4)}>
                        End Customer{" "}
                        <div className="sort_icon-con">
                          <span
                            className="material-icons up-arrwo"
                            style={{
                              color:
                                order === "ASC" && selectedIndex === 4
                                  ? "#873BFF"
                                  : "#667085",
                            }}
                          >
                            arrow_drop_up
                          </span>

                          <span
                            className="material-icons down-arrow"
                            style={{
                              color:
                                order === "DSC" && selectedIndex === 4
                                  ? "#873BFF"
                                  : "#667085",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        </div>
                      </th> */}
                          {/* <th>
                        Tenure{" "}
                        <div className="sort_icon-con">
                          <span
                            className="material-icons up-arrwo"
                            style={{
                              color: order === "ASC" ? "#873BFF" : "#667085",
                            }}
                          >
                            arrow_drop_up
                          </span>

                          <span
                            className="material-icons down-arrow"
                            style={{
                              color: order === "DSC" ? "#873BFF" : "#667085",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        </div>
                      </th> */}
                          <th onClick={() => sorting("status", 5)}>
                            Status{" "}
                            <div className="sort_icon-con">
                              <span
                                className="material-icons up-arrwo"
                                style={{
                                  color: order === "ASC" && selectedIndex === 5 ? "#873BFF" : "#667085",
                                }}
                              >
                                arrow_drop_up
                              </span>

                              <span
                                className="material-icons down-arrow"
                                style={{
                                  color: order === "DSC" && selectedIndex === 5 ? "#873BFF" : "#667085",
                                }}
                              >
                                arrow_drop_down
                              </span>
                            </div>
                          </th>

                          {/* <th
                        style={{
                          opacity: "0",
                          visibility: "0",
                        }}
                      >
                        Status{" "}
                        <div className="sort_icon-con">
                          <span
                            className="material-icons up-arrwo"
                            style={{
                              color: order === "ASC" ? "#873BFF" : "#667085",
                            }}
                          >
                            arrow_drop_up
                          </span>

                          <span
                            className="material-icons down-arrow"
                            style={{
                              color: order === "DSC" ? "#873BFF" : "#667085",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        </div>
                      </th> */}
                        </tr>
                      </thead>
                      {currentPaymentFinance.length > 0 && (
                        <tbody className="table-head" style={{ width: "100%" }}>
                          {currentPaymentFinance?.map((user, index) => (
                                                        <tr
                                                            key={index}
                                                            className="each_row"
                                                            onClick={() => goToDetails(user, "Payment finance")}
                                                        >
                                                            <td
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "8px",
                                                                }}
                                                            >
                                                                <div className="profile-d-icon">
                                                                    {user?.business?.name?.slice(0, 2)}
                                                                </div>
                                                                <div className="name-avater-tag">
                                                                    <span> {user?.business?.name} </span>
                                                                    <span className="business_name">
                                                                        {user?.business?.user?.firstName} {user?.business?.user?.lastName}
                                                                    </span>
                                                                </div>
                                                            </td>

                                                            <td> {user?.user?.email} </td>

                                                            <td>
                                                                {" "}
                                                                {currencyPairCheck(user.currency)}
                                                                {AmountCheck(user.requestedAmount)}{" "}
                                                            </td>
                                                            {/* <td>{user._id}</td> */}
                                                            <td>
                                                                {" "}
                                                                {new Date(user.createdAt).toDateString()}{" "}
                                                                {new Date(user.createdAt).toLocaleTimeString()}{" "}
                                                            </td>
                                                            {/* <td> {user?.businessName}</td> */}
                                                            {/* <td>{user.tenure} Days</td> */}
                                                            <td
                                                                style={{
                                                                    color: statusColors[user?.status],
                                                                }}
                                                            >
                                                                {user.status}{" "}
                                                            </td>

                                                            {/* <td
                            className="view_account"
                            onClick={() =>
                              goToDetails(user, "Receivables finance")
                            }
                          >
                            View
                          </td> */}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            )}{" "}
                        {currentPaymentFinance.length === 0 && (
                                                <div className="empty_lg">
                                                    <img src={empty || "/placeholder.svg"} alt="" />
                                                    <div className="bg_lg_dm">
                                                        <h4>No Trade credit Transaction</h4>
                                                        <span>Finance will show here.</span>
                                                    </div>
                                                </div>
                                            )}
                                        </table>

                                        <div className="page-container">
                                            <PaginationV2
                                                gotoNext={() => {
                            if (paymentFinanceCurrentPage === paymentFinancePageSize) {
                                                        return;
                                                    }
                            setPaymentFinanceCurrentPage((page) => page + 1);
                                                }}
                                                gotoPrev={() => {
                                                  if (paymentFinanceCurrentPage === 1) {
                                                        return;
                                                    }
                                                  setPaymentFinanceCurrentPage((page) => page - 1);
                                                }}
                          gotoPage={(page) => setPaymentFinanceCurrentPage(page)}
                          paginationData={paginationData(paymentFinancePageSize)}
                          activePage={paymentFinanceCurrentPage}
                                            />
                                        </div>
                                    </div>
                            )}
                        </div>
                    )}
                    {/* Inventory finance Tabs */}
                    {tab === "Inventory finance" && (
                        <div className="lg-card">
                            <div
                                className="md-cl"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="search-dl"
                                    style={{
                                        width: "100%",
                                    }}
                                >
                                    <div
                                        className="search-l flex gap-[6px] items-center py-[10px] px-[14px] bg-[#ECEFF3] rounded-[8px] w-[320px]"
                                    >
                                        <img src={sech || "/placeholder.svg"} alt="" />
                                        <input
                                            type="text"
                                            placeholder="Search by customer name"
                                            defaultValue={search}
                                            onChange={(e) => {
                                                debouncedSetSearch(e.target.value)
                                            }}
                                            className="outline-none border-none bg-[#ECEFF3] w-full h-[30px]"
                                        />
                                    </div>
                                </div>
                                <div className="search-ls">
                                    <div className="eacl-lft-filter" onClick={() => setisSort(!isSort)}>
                                        {isSort && (
                                            <div className="fixed-fliterbox">
                                                <div className="inner_fixed_col">
                                                    <div className="main_fix_filter">
                                                        {sort.map((statuss, index) => (
                                                            <div
                                                                className="filter_each_none"
                                                                style={{
                                                                    background: selectedindexsort === index ? "#F4F0FF" : "",
                                                                    borderRadius: "8px",
                                                                }}
                                                                key={index}
                                                                onClick={() => {
                                                                    setselectedindexsort(index);
                                                                    setselectedsort(statuss);
                                                                    setisSort(false); // Close dropdown after selection
                                                                }}
                                                            >
                                                                <span> {statuss} </span>
                                                                {selectedindexsort === index && (
                                                                    <>
                                                                        <img src={mark || "/placeholder.svg"} alt="" />
                                                                    </>
                                                                )}{" "}
                                                            </div>
                                                        ))}{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <span className="type">Sort </span>

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "2px",
                                                color: "#344054",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                                lineHeight: "19.6px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {selectedsort}
                                            <span className="material-icons">expand_more</span>
                                        </div>
                                    </div>

                                    <div className="eacl-lft-filter" onClick={() => setisStatus(!isStatus)}>
                                        {isStatus && (
                                            <div className="fixed-fliterbox">
                                                <div className="inner_fixed_col">
                                                    <div className="main_fix_filter">
                                                        {status.map((statuss, index) => (
                                                            <div
                                                                className="filter_each_none"
                                                                style={{
                                                                    background: selectedindexstatus === index ? "#F4F0FF" : "",
                                                                    borderRadius: "8px",
                                                                }}
                                                                key={index}
                                                                onClick={() => {
                                                                    setselectedindexstatus(index);
                                                                    setselectedstatus(statuss);
                                                                }}
                                                            >
                                                                <span> {statuss} </span>
                                                                {selectedindexstatus === index && (
                                                                    <>
                                                                        <img src={mark || "/placeholder.svg"} alt="" />
                                                                    </>
                                                                )}{" "}
                                                            </div>
                                                        ))}{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <span className="type">Status :</span>

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "2px",
                                                color: "#344054",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                                lineHeight: "19.6px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {selectedstatus}
                                            <span className="material-icons">expand_more</span>
                                        </div>
                                    </div>
                                    <div className="eacl-lft-filter">
                                        <span
                                            className="type text-[#98A2B3] font-[400] text-sm cursor-pointer"
                                            onClick={() => handleClearFilter()}
                                        >
                                            Clear filter
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {isloading ? (
                                <div className="loadingdata" >
                                    < LoaderDate />
                                </div>
                            ) : (
                                    <div style={{ overflow: "auto" }}>
                                        <table className="table row-datatable">
                                            <thead className="table-head">
                                                <tr>
                                                    <th onClick={() => sorting("user['firstName']", 0)}>
                                                        Name
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 0 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 0 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <th onClick={() => sorting("email", 1)}>
                                                        Email address{" "}
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 1 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 1 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <th onClick={() => sorting("phoneNumber", 2)}>
                                                        Amount{" "}
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 2 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 2 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>
                                                    {/* <th onClick={() => sorting("phoneNumber", 2)}>
                        ID{" "}
                        <div className="sort_icon-con">
                          <span
                            className="material-icons up-arrwo"
                            style={{
                              color:
                                order === "ASC" && selectedIndex === 2
                                  ? "#873BFF"
                                  : "#667085",
                            }}
                          >
                            arrow_drop_up
                          </span>

                          <span
                            className="material-icons down-arrow"
                            style={{
                              color:
                                order === "DSC" && selectedIndex === 2
                                  ? "#873BFF"
                                  : "#667085",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        </div>
                      </th> */}

                                                    <th onClick={() => sorting("createdAt", 9)}>
                                                        Date
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 3 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 3 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>

                                                    {/* <th onClick={() => sorting("country", 4)}>
                        End Customer{" "}
                        <div className="sort_icon-con">
                          <span
                            className="material-icons up-arrwo"
                            style={{
                              color:
                                order === "ASC" && selectedIndex === 4
                                  ? "#873BFF"
                                  : "#667085",
                            }}
                          >
                            arrow_drop_up
                          </span>

                          <span
                            className="material-icons down-arrow"
                            style={{
                              color:
                                order === "DSC" && selectedIndex === 4
                                  ? "#873BFF"
                                  : "#667085",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        </div>
                      </th> */}
                                                    {/* <th>
                        Tenure{" "}
                        <div className="sort_icon-con">
                          <span
                            className="material-icons up-arrwo"
                            style={{
                              color: order === "ASC" ? "#873BFF" : "#667085",
                            }}
                          >
                            arrow_drop_up
                          </span>

                          <span
                            className="material-icons down-arrow"
                            style={{
                              color: order === "DSC" ? "#873BFF" : "#667085",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        </div>
                      </th> */}
                                                    <th onClick={() => sorting("status", 5)}>
                                                        Status{" "}
                                                        <div className="sort_icon-con">
                                                            <span
                                                                className="material-icons up-arrwo"
                                                                style={{
                                                                    color: order === "ASC" && selectedIndex === 5 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_up
                                                            </span>

                                                            <span
                                                                className="material-icons down-arrow"
                                                                style={{
                                                                    color: order === "DSC" && selectedIndex === 5 ? "#873BFF" : "#667085",
                                                                }}
                                                            >
                                                                arrow_drop_down
                                                            </span>
                                                        </div>
                                                    </th>
                                                    {/*
                      <th
                        style={{
                          opacity: "0",
                          visibility: "0",
                        }}
                      >
                        Status{" "}
                        <div className="sort_icon-con">
                          <span
                            className="material-icons up-arrwo"
                            style={{
                              color: order === "ASC" ? "#873BFF" : "#667085",
                            }}
                          >
                            arrow_drop_up
                          </span>

                          <span
                            className="material-icons down-arrow"
                            style={{
                              color: order === "DSC" ? "#873BFF" : "#667085",
                            }}
                          >
                            arrow_drop_down
                          </span>
                        </div>
                      </th> */}
                                                </tr>
                                            </thead>
                                            {currentTableDataInventory.length > 0 && (
                                                <tbody className="table-head" style={{ width: "100%" }}>
                                                    {currentTableDataInventory?.map((user, index) => (
                                                        <tr
                                                            key={index}
                                                            className="each_row"
                                                            onClick={() => goToDetails(user, "Inventory finance")}
                                                        >
                                                            <td
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "8px",
                                                                }}
                                                            >
                                                                <div className="profile-d-icon">
                                                                    {user?.business?.name?.slice(0, 2)}
                                                                </div>
                                                                <div className="name-avater-tag">
                                                                    <span> {user?.business?.name} </span>
                                                                    <span className="business_name">
                                                                        {user?.business?.user?.firstName} {user?.business?.user?.lastName}
                                                                    </span>
                                                                </div>
                                                            </td>

                                                            <td> {user?.user?.email} </td>

                                                            <td>
                                                                {" "}
                                                                {currencyPairCheck(user.currency)}
                                                                {AmountCheck(user.requestedAmount)}{" "}
                                                            </td>
                                                            {/* <td>{user._id}</td> */}
                                                            <td>
                                                                {" "}
                                                                {new Date(user.createdAt).toDateString()}{" "}
                                                                {new Date(user.createdAt).toLocaleTimeString()}{" "}
                                                            </td>
                                                            {/* <td> {user?.businessName}</td> */}
                                                            {/* <td>{user.tenure} Days</td> */}
                                                            <td
                                                                style={{
                                                                    color: statusColors[user?.status],
                                                                }}
                                                            >
                                                                {user.status}{" "}
                                                            </td>

                                                            {/* <td
                            className="view_account"
                            onClick={() =>
                              goToDetails(user, "Inventory finance")
                            }
                          >
                            View
                          </td> */}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            )}{" "}
                                            {currentTableDataInventory.length === 0 && (
                                                <div className="empty_lg">
                                                    <img src={empty || "/placeholder.svg"} alt="" />
                                                    <div className="bg_lg_dm">
                                                        <h4>No Trade credit Transaction</h4>
                                                        <span>Finance will show here.</span>
                                                    </div>
                                                </div>
                                            )}
                                        </table>

                                        <div className="page-container">
                                            <PaginationV2
                                                gotoNext={() => {
                                                    if (inventoryCurrentPage === inventoryPageSize) {
                                                        return;
                                                    }
                                                    setInventoryCurrentPage((page) => page + 1);
                                                }}
                                                gotoPrev={() => {
                                                    if (inventoryCurrentPage === 1) {
                                                        return;
                                                    }
                                                    setInventoryCurrentPage((page) => page - 1);
                                                }}
                                                gotoPage={(page) => setInventoryCurrentPage(page)}
                                                paginationData={paginationData(inventoryPageSize)}
                                                activePage={inventoryCurrentPage}
                                            />
                                        </div>
                                    </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default FinanceHome;
